module.exports = __webpack_public_path__ + "static/media/img2-3.cabe16ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/css/img/tabla_oport/papa/nutricheck_foliar/K/img2-3.png
// module id = 2050
// module chunks = 3